import {useEffect, useState} from 'react';

interface Size {
    width: number;
    height: number;
}

const getWindowSize = () => {
    return {
        width: window.innerWidth || 1792,
        height: window.innerHeight || 1120,
    };
};

const useWindowSize = () => {
    const [size, setSize] = useState<Size>(getWindowSize());

    useEffect(() => {
        const load = () => setSize(getWindowSize());
        window.addEventListener('resize', load);
        return () => {
            window.removeEventListener('resize', load);
        };
    }, []);

    return size;
};

export default useWindowSize;
